import CoachingPlanProgress from 'records/CoachingPlanProgress';
import {PlanId} from 'records/CoachingPlan';
import {UserId} from 'records/User';
import {Data, Double, RecordProps} from '@store/@types/util';

interface CoachingPlanVelocityInterface {
  planId: PlanId;
  planProgress: CoachingPlanProgress;
  repId: UserId;
  changeInScore?: Double;
  firstScore?: Double;
  lastScore?: Double;
}
export class CoachingPlanVelocity extends Data<CoachingPlanVelocityInterface>({
  planId: undefined,
  planProgress: undefined,
  repId: undefined,
  changeInScore: undefined,
  firstScore: undefined,
  lastScore: undefined,
}) {
  constructor(obj: RecordProps<CoachingPlanVelocityInterface> = {}) {
    super({
      ...obj,
      planProgress: new CoachingPlanProgress(obj.planProgress),
    });
  }
}
